import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { GATEWAY_URL } from '@app/core/constants';
import { InboundFaxesQuery, TableSearchResult } from '@app/core/model';
import { InboundFaxesTableModel } from '@app/shared/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InboundFaxesTableApiService {
  private readonly gatewayUrl: string = inject(GATEWAY_URL);
  private readonly http: HttpClient = inject(HttpClient);

  public getTableByInboxId(
    inboxId: string,
    query: InboundFaxesQuery
  ): Observable<TableSearchResult<InboundFaxesTableModel>> {

    return this.http.post<TableSearchResult<InboundFaxesTableModel>>(
      `${this.getBaseUrl()}/inbound-fax/${inboxId}`,
      query
    );
  }

  private getBaseUrl(): string {
    return `${this.gatewayUrl}/api/IFA/odata`;
  }
}
